import { BaseModel } from './base-model';
import { ZoneModel } from './zone-model';

export class CloudModel implements BaseModel {
  public id: string;
  public configuration: {
    logoUrl: string;
    backgroundUrl: string;
    zoneGroups: {
      name: string;
      dashboard: boolean;
      zones: Array<string> | Array<ZoneModel>;
      stats: Array<{
        label: string;
        values: Array<number>;
        units: string;
      }>;
    }[];
    productionMeterId: Array<string>;
    consumptionMeterId: Array<string>;
  };

  init() {}
}
